import { css } from '@emotion/css'
import { spacing, breakpoint, zIndex, mediaQueryHelper } from '@offerzen/pinata-shame'

const styles = {
  sticky: css({
    [mediaQueryHelper(breakpoint.tablet)]: {
      position: 'fixed',
      top: spacing.large,
      right: spacing.medium,
      zIndex: zIndex.level5,
      width: 280,
    },

    [mediaQueryHelper(breakpoint.desktop)]: {
      right: 'initial',
      width: 320,
    },
  }),
}

export default styles
